module.exports = __webpack_public_path__ + "img/research_iton_1.17d5fb8a.png";